module.exports = __webpack_public_path__ + "static/Organ Transplant Solutions-36168212185e31b8184eaa3b9b5001c8.pdf";